<div class="modal-header ai-modal-header">
  <div class="ai-modal-title">
    <i class="las la-robot ai-icon"></i>
    <h4 class="modal-title">{{ 'aiIrm.title' | translate }}</h4>
  </div>
  <div class="ai-header-actions">
    <button *ngIf="selectedOption" class="btn btn-sm btn-outline-light mr-2" (click)="goBack()">
      <i class="las la-arrow-left"></i> {{ 'ai.back' | translate }}
    </button>
    <button type="button" class="close" (click)="close()">
      <span>&times;</span>
    </button>
  </div>
</div>

<div class="modal-body ai-modal-body">

  <!-- SELECTOR DE ANÁLISIS -->
  <div *ngIf="!selectedOption" class="ai-options-container">
    <p class="ai-prompt-text">{{ 'ai.selectPrompt' | translate }}</p>
    <div class="ai-options-grid">
      <div
        *ngFor="let opt of options"
        class="ai-option-card"
        (click)="selectOption(opt)"
      >
        <i class="{{ opt.icon }} ai-option-icon"></i>
        <div class="ai-option-label">{{ opt.label | translate }}</div>
        <div class="ai-option-desc">{{ opt.description | translate }}</div>
      </div>
    </div>
  </div>

  <!-- RESULTADO / STREAMING -->
  <div *ngIf="selectedOption" class="ai-result-container">
    <div class="ai-result-header">
      <i class="{{ selectedOption.icon }}"></i>
      <span>{{ selectedOption.label | translate }}</span>
    </div>

    <div class="ai-result-body">
      <div *ngIf="isStreaming && streamStatus" class="ai-loading mb-2">
        <div class="spinner-grow spinner-grow-sm text-primary" role="status"></div>
        <span class="ml-2">{{ streamStatus }}</span>
      </div>

      <div
        *ngIf="rawMarkdown"
        class="ai-rendered-content"
        [innerHTML]="renderedHtml"
      ></div>

      <span *ngIf="isStreaming" class="ai-cursor">▋</span>
    </div>

    <div *ngIf="isDone" class="ai-result-footer">
      <button class="btn btn-outline-danger btn-sm" (click)="exportPdf()">
        <i class="las la-file-pdf"></i> {{ 'ai.exportPdf' | translate }}
      </button>
    </div>
  </div>

</div>
